export const SECTORS = [
  "Climatización", "Aire acondicionado", "Fontanería", "Electricidad",
  "Piscinas", "Calderas", "Energía solar", "Ascensores", "Jardinería",
  "Control de plagas", "Mantenimiento industrial", "Comunidades de vecinos",
  "Multiservicio", "Limpieza técnica", "Mantenimiento de edificios",
];

export const PRIORITIES = [
  { value: "baja", label: "Baja", color: "#86868B", bg: "#F5F5F7" },
  { value: "media", label: "Media", color: "#0066CC", bg: "#EAF2FC" },
  { value: "alta", label: "Alta", color: "#FF9500", bg: "#FFF4E5" },
  { value: "urgente", label: "Urgente", color: "#FF3B30", bg: "#FFEBEA" },
];

export const AVISO_STATUS = [
  { value: "nuevo", label: "Nuevo", color: "#0066CC", bg: "#EAF2FC" },
  { value: "asignado", label: "Asignado", color: "#5856D6", bg: "#EEEEFB" },
  { value: "en_progreso", label: "En progreso", color: "#FF9500", bg: "#FFF4E5" },
  { value: "resuelto", label: "Resuelto", color: "#34C759", bg: "#E9F9EE" },
];

export const WO_STATUS = [
  { value: "pendiente", label: "Pendiente", color: "#86868B", bg: "#F5F5F7" },
  { value: "en_curso", label: "En curso", color: "#FF9500", bg: "#FFF4E5" },
  { value: "completada", label: "Completada", color: "#34C759", bg: "#E9F9EE" },
  { value: "cancelada", label: "Cancelada", color: "#FF3B30", bg: "#FFEBEA" },
];

export function findMeta(list, value) {
  return list.find((x) => x.value === value) || list[0];
}

export function eur(n) {
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);
}
